import { api } from "@/lib/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../use-toast";
import { getPaymentQueryOptions, getPaymentsQueryOptions } from "./get.hooks";

export function useDeletePayment(
  reservationId: string,
  opts?: {
    onSuccess?: () => void;
    onError?: () => void;
  },
) {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: (id: string) =>
      api.delete<void>(`/api/payments/$id`, undefined, {
        pathReplace: { $id: id },
      }),
    onSuccess: (_, id) => {
      queryClient.setQueryData(
        getPaymentsQueryOptions(reservationId).queryKey,
        (old) => old?.filter((d) => d.id !== id),
      );
      queryClient.resetQueries({
        queryKey: getPaymentQueryOptions(id).queryKey,
      });
      toast({
        title: "toast.paymentDeleted",
        variant: "success",
      });
      opts?.onSuccess?.();
    },
    onError: () => {
      toast({
        title: "toast.deletePaymentError",
        variant: "destructive",
      });
      opts?.onError?.();
    },
  });
}
